import RichText from '@onclicks/sharedcomponents/RichText'
import { cn } from '@onclicks/utilities/ui'
import React from 'react'

import type { ContentBlock as ContentBlockType } from '@onclicks/payload-types'
import { LinkBar } from '../LinkBar'
import { courierPrime } from '@onclicks/utilities/fontImport'

export const ContentWithLinkBar: React.FC<ContentBlockType> = (props) => {
  const { columns } = props

  const colsSpanClasses = {
    full: 'lg:col-span-12',
    half: 'lg:col-span-6',
    oneThird: 'lg:col-span-4',
    twoThirds: 'lg:col-span-8',
  }

  return (
    <div className="my-10">
      <div className="grid grid-cols-4 lg:grid-cols-12 gap-y-8 gap-x-16 items-center">
        {columns &&
          columns.length > 0 &&
          columns.map((col, index) => {
            const { title, size, links } = col

            return (
              <div
                className={cn(`lg:pt-5 col-span-4 ${colsSpanClasses[size!]}`, {
                  'md:col-span-2': size !== 'full',
                })}
                key={index}
              >
                {title && (
                  <h1
                    className={`text-center font-semibold text-4xl mb-5 ${courierPrime.className}`}
                  >
                    {title}
                  </h1>
                )}
                {links && links.length > 0 && (
                  <LinkBar mode="nav" links={links} className="w-full border-y border-black py-3" />
                )}
              </div>
            )
          })}
      </div>
    </div>
  )
}
